<template>
    <div class="header">
        <img class="header-img" src="../assets/personal.png">
        <div v-if="index==1" style="display: flex;align-items: center;">
            <img class="header-img1" src="../assets/html.png">
            <img class="header-img1" src="../assets/css.png">
            <img class="header-img1" src="../assets/javascript.png">
            <img class="header-img1" src="../assets/logo.png">
        </div>
        <div v-if="index==2" style="display: flex;align-items: center;">
            <img class="header-img1" src="../assets/unity.png">
            <img class="header-img1" src="../assets/C.png">
        </div>
        <div>
            <el-button :style="{color:index==1?'blueviolet':'rgb(64, 158, 255)'}" @click="goWeb" class="header-btn" type="text">前端</el-button>
            <el-button :style="{color:index==2?'blueviolet':'rgb(64, 158, 255)'}" @click="goUnity" class="header-btn" type="text">Unity</el-button>
            <el-button :style="{color:index==3?'blueviolet':'rgb(64, 158, 255)'}" @click="goOther" class="header-btn" type="text">其他</el-button>
        </div>
    </div>
</template>


<script>
import { nextTick } from 'vue'

export default {
  data() {
    return {
        index:1
    }
  },
  created(){
    setInterval(()=>{
        this.index=this.$route.path.slice(1,4)=="web"?1:(this.$route.path.slice(1,4)=="uni"?2:3)
    },500)
  },
  methods:{
    goWeb(){
        this.$router.push("/webinfo").catch(err=>{})
        this.index=1
    },
    goUnity(){
        this.$router.push("/unityinfo").catch(err=>{})
        this.index=2
    },
    goOther(){
        this.$router.push("/other1").catch(err=>{})
        this.index=3
    },
  }
}
</script>

<style>
.header{
    display: flex;
    width: 100%;
    justify-content: space-between;
}
.header-img{
    height: 60px;
    margin-left: 20px;
}
.header-img1{
    height: 40px;
    margin-left: 20px;
}
.header-btn{
    font-size: 1.2rem !important;
    margin-right: 10px !important;
}
</style>